import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IRestoreBoostingCharacterCards } from '../../modals/energy-restoring/energy-restoring.component';

@Component({
  selector: 'app-restore-bossting-card-list',
  templateUrl: './restore-bossting-card-list.component.html',
  styleUrls: ['./restore-bossting-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestoreBosstingCardListComponent {
  @Input() cards: IRestoreBoostingCharacterCards[] = [];
  @Output() useCard: EventEmitter<{ cardId: number; count: number }> =
    new EventEmitter<{ cardId: number; count: number }>();
  constructor() {}

  ngOnInit(): void {
    this.sortCards();
  }

  public takeCard(card: IRestoreBoostingCharacterCards): void {
    if (card.count > 0) {
      this.useCard.emit({ cardId: card.apiCard.id, count: card.count });
    }
    this.sortCards();
  }
  private sortCards() {
    this.cards.sort((a, b) => {
      return a.apiCard.meta.value - b.apiCard.meta.value;
    });
  }
}
